import { combineReducers, configureStore } from "@reduxjs/toolkit";
import officesReducer from "./slices/officesSlice";
import certificationsReducer from "./slices/certificationsSlice";

export type AppState = ReturnType<typeof store.getState>;

const reducers = combineReducers({
  certifications: certificationsReducer,
  offices: officesReducer
});

const store = configureStore({reducer: reducers});
export default store;



// WEBPACK FOOTER //
// ./src/store/store.ts